export default function colorCodes(stageOrder, role) {
  switch (role) {
    case "CA":
      return "081753";
  }
}
